//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "./tableOfContentsHistoryModalView",
  "modules/shared/sortableList/sortableListModule",
  "modules/authoringAdmin/tableOfContents/tableOfContentsModel",
], function (Marionette, Messenger, TableOfContentsHistoryModalView, SortableListModule) {
  "use strict";

  var TableOfContentsHistoryModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "tableOfContentsHistoryModal";
    },
    show: function (tableOfContents) {
      this.layout = new TableOfContentsHistoryModalView.tableOfContentsHistoryModalLayout({
        model: tableOfContents,
      });
      var headers = Messenger.reqres.request("tableOfContents:history:headers");
      this.tableOfContentsHistoryList = this.addSubModule(
        new SortableListModule({
          region: this.layout.tableOfContentsHistory,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: "tableOfContentsHistory",
        }),
      );

      this.layout.on(
        "done",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews(tableOfContents);
        },
        this,
      );

      this.showRegion(this.layout);

      this.tableOfContents = tableOfContents;
    },
    _showSubViews: function (tableOfContents) {
      this.tableOfContentsHistoryList.show(tableOfContents.history());
    },
  });

  return TableOfContentsHistoryModalController;
});
